// extracted by mini-css-extract-plugin
export default {"listScroll":"constructor-list_listScroll__9Rrmz","scroll":"constructor-list_scroll__lc3vO","topGap":"constructor-list_topGap__whRfT"};